"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGenderMale = function SvgGenderMale(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 11 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#179FE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.233 5.79 1.928.265a1 1 0 0 0 .136.009H5.67a1 1 0 0 0 .134-.01l2.012-.271a1 1 0 0 1 1.053 1.384L6.221 13.36a1 1 0 0 0-.08.393v3.565a1 1 0 0 1-1 1H3.972a1 1 0 0 1-1-1v-3.59a1 1 0 0 0-.085-.404L.182 7.184a1 1 0 0 1 1.05-1.394Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.614,
    cy: 2.159,
    r: 2.159
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgGenderMale);
var _default = exports["default"] = Memo;